import styled, { css } from 'styled-components';
import Paragraph from 'components/atoms/Paragraph';
import { ReactComponent as Plus } from 'assets/icons/plus.svg';
import { ReactComponent as ArrowRight } from 'assets/icons/arrow_right.svg';
import { ReactComponent as NotesIcon } from 'assets/icons/notes.svg';
import { ReactComponent as AgendaIcon } from 'assets/icons/agenda.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  height: 64px;
  padding: 0 15px;
  width: 100%;
  background-color: ${({ theme }) => theme.gray5};
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.16);
  z-index: 999999;
`;

export const PageTitle = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  border-left: 2px solid ${({ theme }) => theme.gray3};
  padding-left: 15px;
  height: 48px;
`;

export const Nav = styled.nav`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const NavItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 34px;
  padding: 0 13px;
  border-radius: 5rem;
  border: 2px solid ${({ theme }) => theme.gray4};
  text-decoration: none;
  margin-right: 15px;
  transition: background-color 0.15s ease-in-out;
  overflow: hidden;

  ${Paragraph} {
    margin-left: 8px;
    display: ${({ isHidden }) => (isHidden ? 'none' : 'block')};
  }

  :hover {
    background-color: ${({ theme }) => theme.gray4};
  }
`;

export const StyledNotesIconBig = styled(NotesIcon)`
  height: auto;
  width: 34px;
  margin-right: 15px;
`;

export const StyledAgendaIconBig = styled(AgendaIcon)`
  height: auto;
  width: 34px;
  margin-right: 15px;
`;

export const StyledNotesIcon = styled(NotesIcon)`
  height: 21px;
  width: 21px;
`;

export const StyledAgendaIcon = styled(AgendaIcon)`
  height: 21px;
  width: 21px;
`;

export const StyledCloudIcon = styled.img`
  height: 21px;
  width: 21px;
`;

export const ListWrapper = styled.div`
  width: 300px;
  height: calc(100vh - 64px);
  border-right: 2px solid ${({ theme }) => theme.gray4};
`;

export const List = styled.ul`
  display: flex;
  flex-flow: column-reverse nowrap;
  list-style: none;
  width: 100%;
`;

export const ListItem = styled.li`
  width: 100%;
`;

export const ListTitle = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 15px;
  height: 48px;
  border-bottom: 2px solid ${({ theme }) => theme.gray4};
  text-decoration: none;

  :hover {
    background-color: ${({ theme }) => theme.gray4};
  }

  ${({ isLast }) =>
    isLast
      ? css`
          ::before {
            height: ${isLast * 48 - 24}px !important;
            top: -${(isLast - 1) * 48}px !important;
          }
        `
      : null}

  ${({ isActive }) =>
    isActive
      ? css`
          background-color: ${({ theme }) => theme.gray4};
          cursor: default;
        `
      : null}

${Paragraph} {
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

export const SubList = styled.ul`
  list-style: none;
  margin-left: 25px;

  ${ListTitle} {
    border-color: ${({ theme }) => theme.gray5};

    ::before {
      content: '';
      pointer-events: none;
      position: absolute;
      top: 0;
      left: -15px;
      width: 15px;
      height: 28px;
      border-left: 2px solid ${({ theme }) => theme.gray4};
      border-bottom: 2px solid ${({ theme }) => theme.gray4};
      border-bottom-left-radius: 5px;
    }
  }
`;

export const StyledArrowRight = styled(ArrowRight)`
  fill: ${({ theme }) => theme.textSecondary};
  margin-left: -15px;
  margin-right: 5px;
  transform: rotate(${({ isActive }) => (isActive ? '90deg' : 0)});
  transition: transform 0.15s ease-in-out;
`;

export const StyledPlus = styled(Plus)`
  fill: ${({ theme }) => theme.textSecondary};
  margin-left: -15px;
  margin-right: 5px;
`;

export const AdditionalContent = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-left: auto;
  gap: 15px;
`;
